import React, {Component} from "react";
import {FormGroup, Input, Label, ModalBody} from "reactstrap";
import {Col, Row} from "react-bootstrap";
import {deepCopyObject, showAxiosError} from "../helper/helper";
import DefaultModal from "../accounting/invoice/DefaultModal";
import EditableLabel from "../components/EditableLabel/editableLabel";
import "./barContractCreator.css";
import {validateField} from "../common/validation";
import {isValidObject} from "../common/componentValidation";
import Alert from "react-s-alert";
import {request} from "../helper/APIUtils";
import ReactLoadingTop from "../components/ReactLoadingTop";
import Swal from "sweetalert2";

class BarContractCreator extends Component {
    constructor(props) {
        document.title = "AVUKAT ÜCRET SÖZLEŞMESİ";
        super(props);
        this.state = {
            explanationModal: false,
            explanationModalText: "",
            ownerInformation: {},
            lawyerInformation: {},
            selectedTerm: "",
            selectedTermText: "",
            selectedCost: "",
            selectedCostText: "",
            odenenMiktar: "",
            selectedAuthority: "",
            selectedAuthorityText: "",
            contractNotes: {},
            showTermAddModal: false,
            termList: [],
            editLabel: "Ankara",
            disabledDownloadButton: false
        };
        this.onChangeInformation = this.onChangeInformation.bind(this);
        this.getExplanation = this.getExplanation.bind(this);
        this.onChangeNotes = this.onChangeNotes.bind(this);
        this.addNewLine = this.addNewLine.bind(this);
        this.downloadContract = this.downloadContract.bind(this);
        this.validateContract = this.validateContract.bind(this);
        this.validateLawyerInformation = this.validateLawyerInformation.bind(this);
        this.validateOwnerInformation = this.validateOwnerInformation.bind(this);
        this.validateTermValues = this.validateTermValues.bind(this);
        this.onClickDownload = this.onClickDownload.bind(this);
        this.checkWordCount = this.checkWordCount.bind(this);
    }

    getExplanation(section) {
        switch (section) {
            case "contractParties":
                return <div>
                    <p style={{fontWeight: "bold"}}>TARAFLARLA İLGİLİ
                        <p style={{fontWeight: "normal"}}>
                            <b>A- Sözleşmenin iş sahibi tarafı ile ilgili</b><br/>
                            Avukat ile sözleşme yapan iş sahibinin sözleme yapmaya ilişkin genel hükümlere göre fiil
                            ehliyetine sahip olması gereklidir.<br/>
                            <b>1-</b>Sözleşmenin tarafları bölümünde yazlı olan gerçek ya da tüzel kişilerin sözleşme
                            sonunda da imzası olması gerekir. Aksi halde imzası olmayanlar sözleşmenin tarafı kabul
                            edilemez.<br/>
                            <b>2-</b> Tüzel kişiler yerine sözleşmeyi imzalayanların tüzel kişinin yetkilisi olduğunu
                            gösteren belgenin sözleşmeye eklenmesi veya yetkinin dayandığı belgenin ayırıcı unsurlarının
                            sözleşmede belirtilmesi gerekir. (Örn: ... Noterliğin ..tarih ve.yevmiyeli imza sirküleri
                            gereği şirket müdürü olan gibi)<br/>
                            <b>3-</b> Sözleşmenin tarafı hukuki yardımı alacak dışında üçüncü kişi olabilir.
                            Örnek: Cezaevindeki oğlu için babası ya da bir başkası avukat ile sözleşme yapabilir. Bu
                            halde:<br/>
                            <b>a-)</b> Hukuki yardım alan: Sözleşme dışı üçüncü kişi, <br/>
                            <b>b-)</b> Avukatlık ücretinin borçlusu: Sözleşmeyi üçüncü kişi yarınına imzalayan
                            olacaktır.<br/>
                            <b>4-</b> Sözleşme tarafının, sözleşmeyi okuduğunu kendi el yazsı ile yazmasından sonra
                            imzalaması doğru olacaktır.<br/>
                            <b>5-</b> Lehine sözleşme yapılacak kişi kısıtlı ise, vasinin bu konuda vesayet makamından
                            izin almış olması yanında sözleşme de vesayet makamının denetimine tabiidir.<br/>
                            <b>6-</b> Vekaleten sözleşmeyi imza edecek kişinin vekaletnamesinde sözleşme yapması
                            yetkisinin olması yani kişi borç altına sokacak yetkisinin olması gereklidir.<br/>
                            <b>7-</b> Sözleşmede kefilin bulunması halinde kefilin sorumlu olduğu miktar ve sorumluluk
                            süresinin el yazısı ile yazılması gereklidir.<br/>
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>A- Sözleşmenin avukat tarafı ile ilgili</b><br/>
                            <b>1-</b> Hukuki yardım sırasında iş sahibi ile nasıl ve hangi yollarla iletişim
                            kurulacağının yazılması,<br/>
                            <b>2-</b> Hukuki yardıma dahil edilecek başka avukatlar önceden belli ise isimlerinin
                            yazılması ve başka avukatlar dahil edilse dahi iş sahibine karşı sözleşme tarafı avukatın
                            sorumluluğunun aynen devam edeceğinin açıklanarak yazılması (bu husus yasal gerçeklik
                            olmasına rağmen iş sahipleri tarafından bilinmeyebilir, yazılması iş sahibinin güven
                            duygusunun olumsuz etkilenmesini önleyecektir.)
                        </p>
                    </p>
                </div>
            case "contractSubject":
            case "lawyerDo":
                return <div>
                    <p style={{fontWeight: "bold"}}>YAPILACAK HUKUKİ YARDIM İLE İLGİLİ
                        <p style={{fontWeight: "normal"}}>
                            <b>1- İş sahibinin hukuki yardım talebi hakkında açıklamaları</b><br/>
                            Bu bölümde: Avukat müvekkil görüşme tutanaklarında müvekkilin anlattıklarının özeti
                            yazılmalı. Ayrıca:<br/>
                            <b>a-) Tereddüte ve yoruma yer vermeyecek şekilde somutlaştırılması gerekir.</b><br/>
                            Çünkü: Hukuki yardım somutlaştırılmadığı takdirde bu belirsizlik ileride taraflar arasında
                            ihtilafa neden olabilmektedir. Şöyle ki Hukuki yardım için: "...trafik kazasından doğan
                            davalar" denildiğinde, ve tarafların ilişkisi azil ile sonlandığında, avukat tarafından
                            açılan ücret alacağı davasında iş sahibi "avukat ceza davama girmedi, soruşturma aşamasında
                            hazır bulunmadı vs. demekte, avukat ise sadece hukuk davasını üstlendiğini iddia
                            etmektedir."
                            <br/>
                            Sözleşmede üstlenilen hukuki yardımın tanımı bu ve benzeri olumsuzluklara neden vermeyecek
                            açıklıkta olmalıdır.<br/>
                            Örnekler:<br/>
                            <i>1) " .... tarihinde meydana gelen trafik kazası nedeniyle ......sayılı dosyada hukuki
                                yardım yapılacaktır"<br/>
                                2) Tazminat davasında, hukuki yardım yapılacaktır.<br/>
                                3) Sigorta şirketine müracaat edilecek anlaşma sağlanamaz ise ceza ve tazminat davası
                                ile icra dosyasında hukuki yardım yapılacaktır.</i><br/>
                            <b>b-) Başka ilde yapılacak hukuki yardımların nasıl yapılacağının detaylı açıklanması
                                gerekir.</b><br/>
                            <b>b1)</b> Masraftan tasarruf amacıyla gidilmeyecek duruşmalar öngörülmesi halinde bunun
                            önceden kararlaştırılması ve yazılması gerekir. Örnek: Bir önceki ara kararı infaz olmamış
                            ise (örnek bilirkişi raporu gelmemiş ise) duruşmaya gidilmeyecektir gibi, <br/>
                            <b>b2)</b> Ulaşımın hangi vasıtalarla yapılacağının, gerektiğinde o ilde konaklanacağının ve
                            bu nedenlerle yapılacak masrafların detaylandırılması faydalıdır.<br/>
                            <b>c-) Yetki belgesi kullanılacağının açıklanması doğru olacaktır. </b><br/>
                            Vekaletnamedeki tevkil yetkisi avukata başka avukatları hukuki yardıma dahil etme hakkı
                            vermesine rağmen, iş sahipleri güven duygularının devamı ve şüpheye düşmemeleri için;
                            sözleşmeye, gerektiğinde büro içinden veya dışından avukatlara yetki verileceğinin ve bu
                            halde de sorumluluğun avukata ait olduğunun yazılması iş sahibinin olası endişelerinin
                            giderilmesine katkı sağlayacaktır.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>2- Avukatın iş sahibinin açıklamaları hakkında değerlendirmesi</b><br/>
                            - Yapılacak hukuki yardım hakkında avukatın düşünceleri:<br/>
                            - Hukuki yardımın nasıl yapılacağına ilişkin İzlenecek yol.<br/>
                            - Avukatın uyuşmazlığa ilişkin yaptığı değerlendirmenin, mutlak sonuç olmadığı avukata ait
                            görüş olduğunun özellikle vurgulanması<br/>
                        </p>
                    </p>
                </div>
            case "price":
                return <div>
                    <p style={{fontWeight: "bold"}}>BELİRLENECEK AKDİ ÜCRET İLE İLGİLİ
                        <p style={{fontWeight: "normal"}}>
                            <b>1- Genel açıklama:</b><br/>
                            <b>a-)</b> Avukatlık ücreti hakkında (akdi ücret, karşı yan ücreti, ücretin yasal taban ve
                            tavan sınırları vs.) bilgi verilmelidir.<br/>
                            <b>b-)</b> Aşağıda yapılan açıklamalara göre ücret belirlenmeli ve ödeme zamanı
                            (muacceliyet) kararlaştırılmış ise bununda açıkça yazılması gerekir. Bilindiği gibi
                            muacceliyet ile ilgili hüküm olmaması halinde ücret hukuki yardımın kesin hüküm / hitam
                            olması ile muaccel olacaktır.<br/>
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>2- Akdi Avukatlık Ücreti Avukatlık Kanununda belirtilen sınırlar içinde maktu, nispi veya
                                karma olarak belirlenebilir.</b><br/>
                            <b>a-)</b>Değeri para ile ölçülebilen dava ve işler için (Avukatlık Asgari Ücret Tarifesi 2.
                            kısım 2. bölümde belirtilen maktu ücretlerinin altında olmamak üzere) ücret: Maktu, nispi
                            ve karma şekilde belirlenebilir.<br/>
                            <b>a1) Maktu ücret</b><br/>
                            Maktu belirlenecek ücret için taban sınır Av. K. 164/4 fıkrası birinci cümlesinin
                            <i>"Avukatlık asgari ücret tarifesi altında vekalet ücreti kararlaştırılamaz."</i> hükmü
                            gereği sözleşmenin yapıldığı tarihte yürürlükte olan Avukatlık Asgari Ücret Tarifesi 2.
                            kısım 2. bölümdeki maktu ücretlerdir.<br/>
                            Avukatlık Kanununda maktu belirlenecek ücret için tavan sınır yoktur. Ancak bu mutlak bir
                            sınırsızlık değildir. Avukatlık Kanununun Genel İlkeleri, Avukatlık Meslek Kuralları,
                            Borçlar Kanununun vekalete ilişkin hükümleri ve hukukun genel ilkeleri BK aşırı yararlanma
                            hükümleri ile MK iyi niyet kuralları çerçevesinde iş sahibinin elde ettiği yarar gözetilerek
                            belirlenen maktu ücrete müdahale edilebilir.<br/>
                            Tüm bu nedenlerle maktu ücretin; iş sahibinin aldığı hukuki yardımla elde ettiği yarar ve
                            avukatın emeği göz önünde bulundurularak kabul edilebilir bir miktar olarak belirlenmesi
                            gerekir.<br/>

                            <b>a2) Nispi ücret</b><br/>
                            Nispi belirlenecek ücret içinde taban sınır Av. K. 164/4 fıkrası birinci cümlesinin
                            <i>"Avukatlık asgari ücret tarifesi altında vekalet ücreti kararlaştırılamaz."</i> hükmü
                            gereği sözleşmenin yapıldığı tarihte yürürlükte olan Avukatlık Asgari Ücret Tarifesi 2.
                            kısım 2. bölümdeki maktu ücretlerdir.<br/>
                            Kanunda taraflarca nispi olarak belirlenecek ücret için ayrıca nispi bir taban sınır
                            konulmamıştır.<br/>
                            Nispi belirlenecek ücret içinde tavan sınır Av. K. 164/2 maddesinin <i>"Yüzde yirmibeşi
                            aşmamak üzere, dava veya hükmolunacak şeyin değeri yahut paranın belli bir yüzdesi avukatlık
                            ücreti olarak kararlaştırılabilir."</i> hükmü gereği %25'dir.<br/>
                            Avukatlık Kanunu 163/2 maddesinin <i>"Avukatlık ücret tavanını aşan sözleşmeler, bu Kanunda
                            belirtilen tavan miktarında geçerlidir"</i> hükmü gereği da tavanı aşan şekildi belirlenen
                            nispi ücretler tavan sınırında geçerli olacak, tavan sınırı aşan kısmı geçersiz
                            olacaktır.<br/>
                            Nispi ücrete esas alınacak müddeabihin sözleşme ile belirlenebilir.<br/>
                            Örn: Davada hükmedilecek asıl alacak + karar tarihine kadarki faizi toplamının % .....
                            gibi<br/>
                            2942 Sayılı Kamulaştırma Kanunu 31/2 maddesi ile konulan yasak gereği "Kamulaştırma
                            davalarında nispi ücret belirlenemez. Aksi davranış için aynı kanunun 33. maddesinde 1
                            yıldan aşağı olmamak üzere hapis ve para cezası öngörülmüştür.<br/>

                            <b>c-) Değeri para ile ölçülemeyen davalarda ücret kural olarak maktu belirlenir.</b><br/>
                            <b>c1)</b> Değeri para ile ölçülemeyen davalar maktu harca tabi davalardır. Bu davalarda
                            kural olarak ücret maktu olarak (5.000 TL. 8.000 TL. gibi) belirlenir. Bu davalara örnek:
                            Ceza davası, mirasçılık belgesi ya da iptali davası gibi davalarda,<br/>
                            <b>c2)</b>Değeri para ile ölçülemeyen davalarda istisnai olarak ücret nispi olarak da
                            belirlenebilir. Örnek ortaklığın giderilmesi davaları, değeri para ile ölçülemeyen
                            davalardır. Çünkü dava sonunda iş sahibinin aktif ve pasif mal varlığında artma a da azalma
                            olmayacaktır. Sadece aktif mal varlığının dava konusu olan kısmı nevi değiştirecek taşınmaz
                            iken paraya dönüşecektir.<br/>
                            Bu nedenle sözleşme olmayan hallerde ortaklığın giderilmesi davalı için ücret, Avukatlık
                            Asgari ücret tarifesine göre maktu olarak belirlenir.<br/>
                            Ancak taraflar sözleşme ile ücreti : Ücretin iş sahibinin hissesine düşecek miktarın % .. si
                            olarak, nispi belirleyebilirler. Bu tür sözleşme geçerli olacaktır.<br/>

                            <b>d-) Baro tavsiye tarifelerine atıf yapılan sözleşmeler ile ilgili</b><br/>
                            Örnek: sözleşmede "........ Barosu Ücret Tarifesine göre ücret ödenecektir" denildiğinde iş
                            sahibinin resmi tarife ile tavsiye niteliğindeki özel tarife arasındaki farkı bilemeyebilir.
                            Bu nedenle öncelikle bu hususun açıklanması gerekir. Açıklamada; bağlayıcı olanın resmi
                            tarife olduğu, özel tarifenin bağlayıcılığının olmadığı, resmi tarifede taban ücretlerin
                            belirlendiği ve ücretin taban ücretin üstünde olması amacıyla, özel tarifedeki ücretlerin
                            esas alındığının açıklanması yerinde olacaktır. Böyle bir açıklamadan sonra, yani iş sahibi
                            özel tarife ile resmi tarife arasındaki fark konusunda bilgilendirildikten sonra tarafların
                            özel tarifeye göre ücret ödeneceğini kararlaştırmaları ücretin tarafların ortak iradeleri
                            ile belirlendiğini gösterecektir. Çünkü Akdi ücrete dair belirlemenin açık ve yanıltıcı
                            olmaması gerekir.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>3- Birden çok hukuki yardımlar için; yukarıda belirtilen sınırlar içinde ayrı-ayrı veya
                                tek ücret belirlenebilir.</b><br/>

                            <b>a-)</b>Bilindiği gibi 1136 Sayılı Avukatlık Kanunu m: 173/1 de <i>"Sözleşmede aksine bir
                            hüküm yoksa, kararlaştırılan avukatlık ücreti yalnızca avukatın üzerine almış olduğu işin
                            karşılığı olup, mukabil dava, bağlantı ve ilişki bulunsa bile başka dava ve icra
                            kovuşturmaları veya her türlü hukukî yardımlar ayrı ücrete tabidir.</i> denilmiştir.<br/>
                            Bu nedenle taraflar arasında sözleşme olmayan hallerde her bir hukuki yardım için ayrı ücret
                            hesaplanır.<br/>

                            <b>b-)</b>Birden çok hukuki yardımın her biri için taraflar Av. K., 173/1 maddesine uygun
                            olarak ayrı-ayrı ücret belirleyebilirler. Veya kanundaki ifade ile "aksine" sözleşme yaparak
                            birden çok hukuki yardım için tek ücret kararlaştırılabilir.<br/>

                            <b>c-) Örnek: </b>İş sahibinin : İş sahibinin farklı amaçlarla hukuki yardım talebi
                            nedeniyle ( örnek trafik kazasından doğan tazminat alacağı + bir başka nedenden doğan bono
                            alacağı + iş akdinden doğan alacakları için veya boşanma davası + kira tespit davası + idari
                            yargı da iptal davası) ücret:<br/>
                            <b>c1)</b> Bu hukuki yardımlar için ayrı ayrı ücret belirlenebilir. Veya<br/>
                            <b>c2)</b> Bu hukuki yardımların tamamı için tek ücret belirlenebilir.<br/>

                            <b>d-) ANCAK</b><br/>
                            İş sahibinin elde etmeyi beklediği tek fayda için yapılan birden çok hukuki yardım için
                            toplamda % 25 sınırını aşmamak gerekir. Örnek: Trafik kazası nedeniyle maddi ve manevi
                            tazminat almak için hukuki yardım talep eden iş sahibine tazminat davası, Sigorta tahkim
                            komisyonunda takip edilecek dava ve icra dosyası için hukuki yardım yapılması üstlenilmiş
                            ise ayrı-ayrı belirlenecek maktu + nispi ücret toplamının elde edilecek tazminat miktarının
                            % 25 sınırını geçmemesi gerekir. Çünkü bu hukuki yardımların tamamında iş sahibinin
                            beklediği fayda tazminat almaktır.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>4- Sözleşmenin lafzı tarafların iradelerini yansıtmalıdır.</b><br/>
                            Bu nedenle ücret hükmü dikkatli yazılmalıdır. Örnek; taraflar yaptıkları görüşmede, açılacak
                            dava ve ilamın icrası için ayrı ayrı ücret ödenmesine karar verdikleri halde sözleşmede:
                            <b>“Dava ve icra dosyasında hukuki yardım yapılacak ve alacağın tahsilinden sonra % 12,5
                                ücret ödenecektir"</b> Denilmiş ise ve taraflar arasında ihtilaf çıkmış ise sözleşmenin
                            lafzı esas alınarak her iki hukuki yardımın tek ücret karşılığı yapılacağının
                            kararlaştırıldığı kabul edilir.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>5- </b>Özel kanunlarda (Örn: Kamulaştırma Kanunu 31. Md) düzenlenen hükümlerde
                            müddeabihin belirli bir yüzdesinin Avukat ücreti olarak belirlenememesi yasağı hallerine
                            dikkat edilmelidir. Bu hallerde Avukat ücreti maktu olarak belirlenebilir.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>6- </b>
                            Avukatlık ücretinin ne zaman muaccel olduğunu düzenleyen bir yasa hükmü bulunmamaktadır.
                            Ancak, Av.K.’nın 171/1 maddesi uyarınca avukatın işi sonuna kadar takip zorunluluğu kuralı
                            ile Avukatlık Asgari Ücret Tarifesinin 2. maddesinde yer alan, ücretin, kesin hüküm elde
                            edinceye kadar olan dava, iş ve işlemlerin karşılığı olduğu kuralı karşısında, avukatlık
                            ücretinin avukat ile iş sahibi arasında aksine sözleşme yok ise, üstlenilen işin bitmesi ile
                            muaccel olduğunun kabulü gerekir. Bu nedenle sözleşme ile aksi kararlaştırılmadıkça Avukat
                            yapmış olduğu işin ücretinin tamamını işin sonunda hak edeceğinden istinaf, temyiz gibi
                            kanun yolları aşamasında olmakla beraber hükmün infaz edildiği, bedelin tahsil olduğu
                            hallerde Avukatın ücretinin tamamını alması iş sahibi yönünden haklı azil sebebi olarak
                            iddia edilebileceğinden bu hususa dikkat edilmelidir.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>7- </b>
                            Üstlenilen işin ederinin bir kısmının tahsil edilmesi, kalan kısmı yönünden işin devam
                            etmesi halinde vekalet ücretinin tahsili ve hapis hakkı konusunda orantılı uygulama
                            yapılmasına dikkat edilmelidir.
                        </p>
                    </p>
                </div>
            case "cost":
                return <div>
                    <p style={{fontWeight: "bold"}}>MASRAFLAR İLE İLGİLİ
                        <p style={{fontWeight: "normal"}}>
                            <b> 1- Masrafların kimin tarafından yapılacağının belirtilmesi gerekir.</b><br/>
                            Bu husus masrafların avukat tarafından üstlenilmesi halinde hayati derecede önemlidir. Çünkü
                            Av. K. 173/2 maddesinden doğan karine nedeniyle sözleşmede belirtilmemiş ve iş sahibi de
                            avukat tarafından yapıldığını kabul etmiyor ise ispatı imkansız derecede zordur. Örnek ıslah
                            harcına ilişkin makbuz üzerinde Avukatın isminin yazılı olması masrafın (sözleşmede
                            yazılmamış ve iş sahibi kabul etmiyor ise) avukat tarafından yapıldığını ispata
                            yetmemektedir.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b> 2- Avans usulü ile çalışılacak ise bu konunun detaylı yazılması gerekir.</b><br/>
                            Ne zaman avans verileceğinin ya da avukat tarafından hangi yolla isteneceğinin, masraf
                            hesabının ne şekilde ve ne kadar süre içinde verileceğinin şeffaflık çerçevesinde
                            belirtilmesi gerekir.
                        </p>
                        <p style={{fontWeight: "bold"}}>
                            3- Masrafların hangi yolla (banka elden) verileceğinin yazılması gerekir.
                        </p>
                        <p style={{fontWeight: "bold"}}>
                            4- Avukat dışında kimlere ödeme yapılabileceğinin ve iş sahibi dışında kimlerin iş sahibi
                            adına
                            ödeme yapacağının yazılması yararlı olacaktır.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>5- Masrafların iş sahibi tarafından ödeneceği kararlaştırılmış ve buna rağmen avukat
                                tarafından masraf yapılması gerekmiş ise:</b><br/>
                            <b>a-)</b> Bu konuda iş sahibinin isteği ile sözleşmede kararlaştırmanın aksine (yapılan
                            masraf belirtilerek, bilirkişi ücreti vs. gibi) masrafın avukat tarafından yapılmasına
                            yönelik yazlı talimat alınmalı veya<br/>
                            <b>b-)</b> Masraf yapıldıktan sonra akabinde görüşme tutanağı ile avukattın yaptığı
                            masrafın, iş sahibinin isteği ile yapıldığı ve iş sahibi tarafından avukata ödeneceği ayrıca
                            ödeneceği yazılmalıdır.
                        </p>
                        <p style={{fontWeight: "normal"}}>
                            <b>6- </b>İfa edilecek işin tüm masrafları iş sahibi tarafından karşılanması esastır. İşin
                            ifası için Avukatın masraf yapması gerektiğinde bu bedel Avukatın talebi üzerinde iş sahibi
                            tarafından karşılanması veya en geç işin sonundaki hesapta nazara alınması gerekir. Bu
                            hususta özel kanunlarda düzenlenen kısıtlamalara ve TBB Meslek kurallarına uygun hükümler
                            düzenlenmesine özen gösterilmelidir.
                        </p>
                    </p>
                </div>
            case "specialConditions":
                return <div>
                    <p>Özel şartlar kısmında taraflarca işin özelliğine uygun olarak belirlenebilecek şartlar
                        yazılabilecektir.</p>
                </div>;
            case "authority":
                return <div>
                    <p>
                        Bu kısımda olası uyuşmazlıklar için tahkim ve yargılama için hangi yargı yolunun seçildiği
                        belirlenebilecek, tahkim şartının belirlenmesi halinde doküman üzerindeki ibare sabit
                        bırakılırsa Ankara Barosu Tahkim Kurulu yetkili kılınacak, başka tahkim belirlenmek istenirse
                        doküman üzerindeki Ankara Barosu kelimeleri üzerine tıklanarak istenen tahkim yeri
                        yazılabilecektir. Yargı yolu yolarak mahkemenin belirlenmesi halinde doküman üzerindeki ibare
                        sabit bırakılırsa Ankara mahkemeleri yetkili kılınacak, başka tahkim belirlenmek istenirse
                        doküman üzerindeki Ankara kelimesi üzerine tıklanarak istenen tahkim yeri yazılabilecektir.
                    </p>
                </div>;
            case "signature":
                return <div>
                    <p style={{fontWeight: "bold"}}>İMZA</p>
                    <ol type="1">
                        <li><p>Sözleşmenin taraflarında iş sahibi tüzel kişi ise sözleşme sonunda da imza sahibinin
                            tüzel kişi olarak yazılması ve adına imza atanın belirtilmesi gerekir.</p>
                        </li>
                        <li><p>İş sahibi tüzel kişi + gerçek kişi ise sözleşme sonunda ayrı ayrı imza açılması
                            gerekir.</p>
                        </li>
                        <li><p>Okur yazar olmayanlar için 5100 sayılı HMK 296. maddesi hükmünün göz önünde tutulması
                            gerekir.</p>
                        </li>
                    </ol>
                </div>;
        }
    }

    onChangeInformation(e) {
        if (e.target.id.includes("lawyer")) {
            let lawyerInformation = deepCopyObject(this.state.lawyerInformation);
            lawyerInformation[e.target.id] = e.target.value;
            this.setState({lawyerInformation: lawyerInformation});
        } else {
            let ownerInformation = deepCopyObject(this.state.ownerInformation);
            ownerInformation[e.target.id] = e.target.value;
            this.setState({ownerInformation: ownerInformation});
        }
    }

    onChangeNotes(e) {
        let contractNotes = deepCopyObject(this.state.contractNotes);
        contractNotes[e.target.id] = e.target.value;
        this.setState({contractNotes: contractNotes})
    }

    onChangeTerms(e, index) {
        let termList = deepCopyObject(this.state.termList);
        termList[index][e.target.id] = e.target.value;
        this.setState({termList: termList});
    }

    addNewLine() {
        let termList = deepCopyObject(this.state.termList);
        let termId = "term_" + termList.length;
        let obj = {};
        obj[termId] = "";
        termList.push(obj);
        this.setState({termList: termList});
    }

    onClickDownload(mediaType) {
        this.setState({disabledDownloadButton: true});
        let validContract = this.validateContract();
        if (validContract.valid) {
            if (validContract.notesEmptyMessage !== "") {
                Swal({
                    title: 'Onay',
                    html: validContract.notesEmptyMessage.slice(0, validContract.notesEmptyMessage.lastIndexOf(",")) + validContract.notesEmptyMessage.slice(validContract.notesEmptyMessage.lastIndexOf(",") + 1) + " alanları boş bırakılmıştır. Devam etmek istiyor musunuz?",
                    showConfirmButton: true,
                    confirmButtonText: "Evet",
                    showCancelButton: true,
                    cancelButtonText: 'Hayır'
                }).then((result) => {
                    if (result.value) {
                        this.downloadContract(mediaType);
                        Swal.close();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.close();
                    }
                })
            } else {
                this.downloadContract(mediaType);
            }
        } else {
            Alert.error(validContract.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
        this.setState({disabledDownloadButton: false});
    }

    downloadContract(mediaType) {
        let data = {
            selectedTerm: this.state.selectedTerm,
            selectedTermText: this.state.selectedTermText,
            selectedCost: this.state.selectedCost,
            selectedCostText: this.state.selectedCostText,
            odenenMiktar: this.state.odenenMiktar,
            selectedAuthority: this.state.selectedAuthority,
            selectedAuthorityText: this.state.selectedAuthorityText,
            termList: this.state.termList,
            editLabelText: this.state.editLabel,
            lawyerInformation: this.state.lawyerInformation,
            ownerInformation: this.state.ownerInformation,
            contractNotes: this.state.contractNotes,
        }

        let params = {
            url: mediaType === "pdf" ? `/barContractCreator/getContractPdf` : `/barContractCreator/getContractDocx`,
            responseType: 'arraybuffer',
            method: "post",
            data: data
        };

        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "contract." + mediaType;
                a.click();
            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
        });
    }

    validateTermValues() {
        let errorMessage = "";
        if (this.state.termList.length === 0) {
            errorMessage += "Vade listesi boş bırakalamaz.";
        } else {
            this.state.termList.map((item, index) => {
                if (item["term_" + index] === "") {
                    errorMessage += "<strong>" + (Number(index) + 1) + " satırdaki vade boş bırakılamaz. </strong><br/>"
                }
            });
        }
        if (errorMessage === "") {
            this.setState({showTermAddModal: false})
        } else {
            Alert.error(errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    validateContract() {
        let error = {};
        let errorMessage = "";
        let validityOwnerInformation = this.validateOwnerInformation();
        let validityLawyerInformation = this.validateLawyerInformation();
        errorMessage += validityOwnerInformation.errorMessage + validityLawyerInformation.errorMessage;

        Object.assign(error, validityOwnerInformation.error);
        Object.assign(error, validityLawyerInformation.error);

        error.selectedTerm = {valid: true};
        if (this.state.selectedTerm === "") {
            error.selectedTerm.valid = false;
            errorMessage += " <strong>Ücret ve Ödeme seçimi boş bırakılamaz.  </strong><br/>";
        } else if (this.state.selectedTerm === "otherTerm" && this.state.termList.length === 0) {
            error.selectedTerm.valid = false;
            errorMessage += " <strong>Ücret ve Ödeme Belirlenen Vadelerde seçilmiş ise Vadeler Listesi boş bırakılamaz.  </strong><br/>";
        }

        error.selectedCost = {valid: true};
        if (this.state.selectedCost === "") {
            error.selectedCost.valid = false;
            errorMessage += " <strong>Masraf seçimi boş bırakılamaz.  </strong><br/>";
        } else if (this.state.selectedCost === "byOwner" && this.state.odenenMiktar === "") {
            error.selectedCost.valid = false;
            errorMessage += " <strong>Masraflar iş sahibi tarafından karşılanacaktır seçili iken Avukata verilen avans miktarı TL veya döviz cinsi boş bırakılamaz.  </strong><br/>";
        }

        error.selectedAuthority = {valid: true};
        if (this.state.selectedAuthority === "") {
            error.selectedAuthority.valid = false;
            errorMessage += " <strong>Tahkim Şartı, Yetki ve Görev seçimi boş bırakılamaz.  </strong><br/>";
        }

        let contractNotes = deepCopyObject(this.state.contractNotes);
        let notesEmptyMessage = "";

        error.contractSubjectNote = this.checkWordCount(contractNotes.contractSubjectNote, 120);
        if (!error.contractSubjectNote.valid) {
            errorMessage += " <strong>II. BÖLÜM SÖZLEŞMENİN KONUSU VE YAPILACAK İŞ Açıklaması " + error.contractSubjectNote.message + "</strong><br/>";
        } else if (contractNotes.contractSubjectNote === undefined || contractNotes.contractSubjectNote === "" || contractNotes.contractSubjectNote.length === 0) {
            notesEmptyMessage += " <strong>II. BÖLÜM SÖZLEŞMENİN KONUSU VE YAPILACAK İŞ Açıklaması, </strong><br/>";
        }

        error.lawyerDoNote = this.checkWordCount(contractNotes.lawyerDoNote, 120);
        if (!error.lawyerDoNote.valid) {
            errorMessage += " <strong>III. BÖLÜM AVUKATIN ÜSTLENDİĞİ HUKUKİ HİZMET Açıklaması " + error.lawyerDoNote.message + "</strong><br/>";
        } else if (contractNotes.lawyerDoNote === undefined || contractNotes.lawyerDoNote === "" || contractNotes.lawyerDoNote.length === 0) {
            notesEmptyMessage += " <strong>III. BÖLÜM AVUKATIN ÜSTLENDİĞİ HUKUKİ HİZMET Açıklaması, </strong><br/>";
        }

        error.priceNote = this.checkWordCount(contractNotes.priceNote, 120);
        if (!error.priceNote.valid) {
            errorMessage += " <strong>IV. ÜCRET VE ÖDEME Açıklaması " + error.priceNote.message + "</strong><br/>";
        } else if (contractNotes.priceNote === undefined || contractNotes.priceNote === "" || contractNotes.priceNote.length === 0) {
            notesEmptyMessage += " <strong>IV. ÜCRET VE ÖDEME Açıklaması, </strong><br/>";
        }

        error.costExplanation = this.checkWordCount(contractNotes.costExplanation, 30);
        if (!error.costExplanation.valid) {
            errorMessage += " <strong>V. MASRAFLAR Açıklaması " + error.costExplanation.message + "</strong><br/>";
        } else if (contractNotes.costExplanation === undefined || contractNotes.costExplanation === "" || contractNotes.costExplanation.length === 0) {
            notesEmptyMessage += " <strong>V. MASRAFLAR Açıklaması, </strong><br/>";
        }

        error.specialConditionsNote = this.checkWordCount(contractNotes.specialConditionsNote, 120);
        if (!error.specialConditionsNote.valid) {
            errorMessage += " <strong>VI. ÖZEL ŞARTLAR Açıklaması " + error.specialConditionsNote.message + "</strong><br/>";
        } else if (contractNotes.specialConditionsNote === undefined || contractNotes.specialConditionsNote === "" || contractNotes.specialConditionsNote.length === 0) {
            notesEmptyMessage += " <strong>VI. ÖZEL ŞARTLAR Açıklaması, </strong><br/>";
        }

        let valid = isValidObject(error);
        return {error: error, valid: valid, errorMessage: errorMessage, notesEmptyMessage: notesEmptyMessage};
    }

    checkWordCount(value, checkCount) {
        let result = {};
        if (value === undefined || value === "") {
            result.valid = true;
            result.message = '';
        } else {
            result.valid = value.length > 0 && Number(checkCount) >= value.split(" ").length;
            result.message = result.valid === true ? '' : ' alanı maksimum ' + checkCount + ' kelime içerebilir.';
        }
        return result;
    }

    validateOwnerInformation() {
        let error = {};
        let errorMessage = "";
        let ownerInformation = deepCopyObject(this.state.ownerInformation);

        error.ownerFormattedName = validateField(undefined, "5,70", ownerInformation.ownerFormattedName);
        if (!error.ownerFormattedName.valid) {
            errorMessage = errorMessage + " <strong>İş Sahibi Ad Soyad/Ünvan bilgisi " + error.ownerFormattedName.message + "</strong><br/>";
        }

        error.ownerIdentifier = validateField("integer", "11,16", ownerInformation.ownerIdentifier);
        if (!error.ownerIdentifier.valid) {
            errorMessage = errorMessage + " <strong>İş Sahibi TCKN/Mersis Numarası bilgisi " + error.ownerIdentifier.message + "</strong><br/>";
        }

        error.ownerAddress = validateField(undefined, "10,100", ownerInformation.ownerAddress);
        if (!error.ownerAddress.valid) {
            errorMessage = errorMessage + " <strong>İş Sahibi Adres bilgisi " + error.ownerAddress.message + "</strong><br/>";
        }

        error.ownerEmail = validateField("email", "6,100", ownerInformation.ownerEmail);
        if (!error.ownerEmail.valid) {
            errorMessage = errorMessage + " <strong>İş Sahibi E-posta bilgisi " + error.ownerEmail.message + "</strong><br/>";
        }

        let valid = isValidObject(error);
        return {error: error, valid: valid, errorMessage: errorMessage};
    }

    validateLawyerInformation() {
        let error = {};
        let errorMessage = "";
        let lawyerInformation = deepCopyObject(this.state.lawyerInformation);

        error.lawyerFormattedName = validateField(undefined, "5,70", lawyerInformation.lawyerFormattedName);
        if (!error.lawyerFormattedName.valid) {
            errorMessage = errorMessage + " <strong>Avukat Ad Soyad/Ünvan bilgisi " + error.lawyerFormattedName.message + "</strong><br/>";
        }

        error.lawyerIdentifier = validateField("integer", "11,16", lawyerInformation.lawyerIdentifier);
        if (!error.lawyerIdentifier.valid) {
            errorMessage = errorMessage + " <strong>Avukat TCKN/Mersis Numarası bilgisi " + error.lawyerIdentifier.message + "</strong><br/>";
        }

        error.lawyerAddress = validateField(undefined, "10,100", lawyerInformation.lawyerAddress);
        if (!error.lawyerAddress.valid) {
            errorMessage = errorMessage + " <strong>Avukat Adres bilgisi " + error.lawyerAddress.message + "</strong><br/>";
        }

        error.lawyerEmail = validateField("email", "6,100", lawyerInformation.lawyerEmail);
        if (!error.lawyerEmail.valid) {
            errorMessage = errorMessage + " <strong>Avukat E-posta bilgisi " + error.lawyerEmail.message + "</strong><br/>";
        }

        let valid = isValidObject(error);
        return {error: error, valid: valid, errorMessage: errorMessage};
    }

    render() {
        return (
            <React.Fragment>
                {/*{this.state.disabledDownloadButton &&*/}
                {/*<div>*/}
                {/*    <ReactLoading type="spinningBubbles" style={{width:"50px", height: "50px", margin: "20px auto 0 auto", fill: "#888"}}/>*/}
                {/*</div>*/}
                {/*}*/}
                <div className='d-flex justify-content-end header-container'>
                    <Row style={{minHeight: '100'}}>
                        <Col sm={12} className="row">
                            <Col sm={12}>
                                <FormGroup row>
                                    <Col sm={6}>
                                        <button className='btn btn-primary pdf-download-button'
                                                disabled={this.state.disabledDownloadButton}
                                                onClick={() => this.onClickDownload("pdf")}><i
                                            className="fas fa-file-pdf"/> Pdf İndir
                                        </button>
                                    </Col>
                                    <Col sm={6}>
                                        <button className='btn btn-primary pdf-download-button'
                                                disabled={this.state.disabledDownloadButton}
                                                onClick={() => this.onClickDownload("docx")}><i
                                            className="fas fa-file-word"/> Word indir
                                        </button>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Col>
                    </Row>
                </div>
                <div id="BarContract" style={{position: 'relative', top: '60px'}}>
                    <div>
                        <div style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            textDecorationLine: "underline",
                            fontSize: "xx-large"
                        }}>AVUKAT ÜCRET SÖZLEŞMESİ
                        </div>
                        <div>
                            <ol className='barContract-list'
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "x-large"
                                }} type="I">
                                <li>
                                    <div>BÖLÜM SÖZLEŞMENİN TARAFLARI<label
                                        className='personal-informations-title'
                                        onClick={(e) => {
                                            this.setState({
                                                explanationModal: !this.state.explanationModal,
                                                explanationModalText: this.getExplanation("contractParties")
                                            })
                                        }}>(Açıklama için tıklayınız)</label></div>
                                    <div>
                                        <Label style={{
                                            fontWeight: "bold",
                                            textDecorationLine: "underline",
                                            fontSize: "18px"
                                        }}>İŞ SAHİBİ</Label>

                                        <div>
                                            <Row style={{minHeight: '100'}}>
                                                <Col sm={12} className="row">
                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="ownerFormattedName" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>ADI
                                                                SOYADI/ÜNVANI</Label>
                                                            <Col sm={8}>
                                                                <Input type="text"
                                                                       id="ownerFormattedName"
                                                                       className="form-control personal-informations-input"
                                                                       style={{
                                                                           border: '0.1em solid #000'
                                                                       }}
                                                                       placeholder="ADI SOYADI/ÜNVANI"
                                                                       value={this.state.ownerInformation && this.state.ownerInformation.ownerFormattedName}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="ownerIdentifier" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>TCKN/MERSİS
                                                                NUMARASI</Label>
                                                            <Col sm={8}>
                                                                <Input type="number"
                                                                       id="ownerIdentifier"
                                                                       className="form-control personal-informations-input"
                                                                       maxLength="16"
                                                                       minLength="10"
                                                                       style={{
                                                                           border: '0.1em solid #000',
                                                                           textAlign: 'left'
                                                                       }}
                                                                       placeholder="TCKN/MERSİS NUMARASI"
                                                                       value={this.state.ownerInformation && this.state.ownerInformation.ownerIdentifier}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="ownerAddress" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>ADRESİ</Label>
                                                            <Col sm={8}>
                                                                <Input type="text"
                                                                       id="ownerAddress"
                                                                       className="form-control personal-informations-input"
                                                                       style={{
                                                                           border: '0.1em solid #000'
                                                                       }}
                                                                       placeholder="ADRESİ"
                                                                       value={this.state.ownerInformation && this.state.ownerInformation.ownerAddress}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="ownerEmail" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>E-POSTA ADRESİ</Label>
                                                            <Col sm={8}>
                                                                <Input type="text"
                                                                       id="ownerEmail"
                                                                       className="form-control personal-informations-input"
                                                                       style={{
                                                                           border: '0.1em solid #000'
                                                                       }}
                                                                       placeholder="E-POSTA ADRESİ"
                                                                       value={this.state.ownerInformation && this.state.ownerInformation.ownerEmail}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                    <div>
                                        <Label style={{
                                            fontWeight: "bold",
                                            textDecorationLine: "underline",
                                            fontSize: "18px"
                                        }}>AVUKAT</Label>

                                        <div>
                                            <Row style={{minHeight: '100'}}>
                                                <Col sm={12} className="row">
                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="lawyerFormattedName" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>ADI
                                                                SOYADI/ÜNVANI</Label>
                                                            <Col sm={8}>
                                                                <Input type="text"
                                                                       id="lawyerFormattedName"
                                                                       className="form-control personal-informations-input"
                                                                       style={{
                                                                           border: '0.1em solid #000'
                                                                       }}
                                                                       placeholder="ADI SOYADI/ÜNVANI"
                                                                       value={this.state.lawyerInformation && this.state.lawyerInformation.lawyerFormattedName}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="lawyerIdentifier" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>TCKN/MERSİS
                                                                NUMARASI</Label>
                                                            <Col sm={8}>
                                                                <Input type="number"
                                                                       id="lawyerIdentifier"
                                                                       className="form-control personal-informations-input"
                                                                       maxLength="16"
                                                                       minLength="10"
                                                                       style={{
                                                                           border: '0.1em solid #000',
                                                                           textAlign: 'left'
                                                                       }}
                                                                       placeholder="TCKN/MERSİS NUMARASI"
                                                                       value={this.state.lawyerInformation && this.state.lawyerInformation.lawyerIdentifier}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="lawyerAddress" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>ADRESİ</Label>
                                                            <Col sm={8}>
                                                                <Input type="text"
                                                                       id="lawyerAddress"
                                                                       className="form-control personal-informations-input"
                                                                       style={{
                                                                           border: '0.1em solid #000'
                                                                       }}
                                                                       placeholder="ADRESİ"
                                                                       value={this.state.lawyerInformation && this.state.lawyerInformation.lawyerAddress}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Label for="lawyerEmail" sm={4}
                                                                   className='personal-informations'
                                                                   style={{fontWeight: 'bold'}}>E-POSTA ADRESİ</Label>
                                                            <Col sm={8}>
                                                                <Input type="text"
                                                                       id="lawyerEmail"
                                                                       className="form-control personal-informations-input"
                                                                       style={{
                                                                           border: '0.1em solid #000',
                                                                       }}
                                                                       placeholder="E-POSTA ADRESİ"
                                                                       value={this.state.lawyerInformation && this.state.lawyerInformation.lawyerEmail}
                                                                       onChange={(e) => this.onChangeInformation(e)}
                                                                       disabled={this.state.disabledDownloadButton}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <br/>
                                    <div>
                                        <p style={{fontWeight: "normal"}}>
                                            Yukarıda yazılı taraflar arasında belirtilen konuda ve anılan ücret ile
                                            Avukatlık Kanunu’nun ilgili maddeleri uyarınca aşağıdaki şartlarla bir ücret
                                            sözleşmesi yapılmıştır.
                                        </p>
                                    </div>
                                </li>
                                <br/>

                                <li>
                                    <div>BÖLÜM SÖZLEŞMENİN KONUSU VE YAPILACAK İŞ<label
                                        className='personal-informations-title' onClick={(e) => {
                                        this.setState({
                                            explanationModal: !this.state.explanationModal,
                                            explanationModalText: this.getExplanation("contractSubject")
                                        })
                                    }}>(Açıklama için tıklayınız)</label></div>
                                    <div>
                                        <p style={{fontWeight: "normal"}}>
                                            İş sahibi, yapılmasını talep ettiği iş konusunda Avukatı bilgilendirmiş ve
                                            yapılacak iş aşağıdaki şekilde tarif edilmiştir.
                                        </p>
                                    </div>

                                    <div>
                                        <textarea
                                            id={"contractSubjectNote"}
                                            data-vlength="0,120"
                                            style={{width: '100%', paddingBottom: 'inherit'}}
                                            // onBlur={this.validateField}
                                            value={this.state.contractNotes["contractSubjectNote"]}
                                            onChange={(e) => this.onChangeNotes(e)}
                                            rows={"7"}
                                            disabled={this.state.disabledDownloadButton}
                                        />
                                    </div>

                                    <div style={{fontWeight: "normal", color: "grey"}}>
                                        <div className='pb-4'>
                                            <p style={{textAlign: "right", padding: '0 3em', margin: '0 0 3em 0'}}>
                                                İŞ SAHİBİ<br/>
                                                {this.state.ownerInformation.ownerFormattedName}<br/>
                                                İMZA
                                            </p>
                                        </div>
                                        <p>
                                            *Sözleşmenin 5070 Sayılı kanun kapsamında e-imza veya m-imza ile imzalanması
                                            halinde fiziki imza gerekmeyecektir.
                                        </p>
                                    </div>
                                </li>
                                <br/>

                                <li>
                                    <div>BÖLÜM AVUKATIN ÜSTLENDİĞİ HUKUKİ HİZMET<label
                                        className='personal-informations-title' onClick={(e) => {
                                        this.setState({
                                            explanationModal: !this.state.explanationModal,
                                            explanationModalText: this.getExplanation("lawyerDo")
                                        })
                                    }}>(Açıklama için tıklayınız)</label></div>
                                    <div>
                                        <p style={{fontWeight: "normal"}}>
                                            Sözleşmede belirlenen ücret yalnız yukarıda konusu belirtilen iş içindir. Bu
                                            işle ilgili olsa da bundan doğacak herhangi bir başka iş bu sözleşmenin
                                            kapsamına girmeyecektir. Karşılık dava açılması ve başkaca bu işle ilgili
                                            uyuşmazlıklar ve kovuşturma işleri çıkması halinde avukata ayrıca vekâlet
                                            ücreti
                                            ödenmesi gerekecektir.
                                        </p>
                                    </div>
                                    <div>
                                         <textarea
                                             id={"lawyerDoNote"}
                                             data-vlength="0,120"
                                             style={{width: '100%', paddingBottom: 'inherit'}}
                                             // onBlur={this.validateField}
                                             value={this.state.contractNotes["lawyerDoNote"]}
                                             onChange={(e) => this.onChangeNotes(e)}
                                             rows={"7"}
                                             disabled={this.state.disabledDownloadButton}
                                         />
                                    </div>
                                </li>

                                <li>
                                    <div>ÜCRET VE ÖDEME<label className='personal-informations-title'
                                                              onClick={(e) => {
                                                                  this.setState({
                                                                      explanationModal: !this.state.explanationModal,
                                                                      explanationModalText: this.getExplanation("price")
                                                                  })
                                                              }}>(Açıklama için tıklayınız)</label></div>
                                    <div onChange={(e) => {
                                        this.setState({
                                            selectedTerm: e.target.value,
                                            selectedTermText: e.target.placeholder
                                        })
                                    }}>
                                        <div>
                                            <Row>
                                                <Col sm={12}>
                                                    <FormGroup row>
                                                        <Col sm={12}>
                                                            <input type="radio" value="inCash" name="term"
                                                                   placeholder="Peşin"
                                                                   disabled={this.state.disabledDownloadButton}/> <label
                                                            className='select-content'>Peşin</label>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <input type="radio" value="jobDone" name="term"
                                                                   placeholder="İş sonunda"
                                                                   disabled={this.state.disabledDownloadButton}/> <label
                                                            className='select-content'>İş sonunda</label>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <input type="radio" value="otherTerm"
                                                                   name="term"
                                                                   placeholder="Belirlenen Vadelerde"
                                                                   disabled={this.state.disabledDownloadButton}/><label
                                                            className='select-content'> Belirlenen
                                                            Vadelerde </label>
                                                            <div
                                                                style={{paddingLeft: "0.5rem", display: "inline"}}>
                                                                <button
                                                                    className='time-button'
                                                                    style={{visibility: this.state.selectedTerm === "otherTerm" ? "visible" : "hidden"}}
                                                                    onClick={() => this.setState({showTermAddModal: true})}
                                                                    disabled={this.state.disabledDownloadButton}>
                                                                    Vadeleri Tasarla
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <div
                                                style={{visibility: this.state.selectedTerm === "otherTerm" && this.state.termList.length > 0 && this.state.termList[0]["term_0"] !== "" && !this.state.showTermAddModal ? "visible" : "hidden"}}>
                                                <table className='contract-table'>
                                                    <thead>
                                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                                        <th width="5%">#</th>
                                                        <th width="95%"></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.termList && this.state.selectedTerm === "otherTerm" && this.state.termList.length > 0 && this.state.termList[0]["term_0"] !== "" && !this.state.showTermAddModal && this.state.termList.map((item, index) =>
                                                            <tr key={index}>
                                                                <td>{(index + 1).toString()}</td>
                                                                <td>{item["term_" + index]}</td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <br/>
                                            <div>
                                                <p style={{fontWeight: "normal"}}>
                                                    Sözleşme kapsamında üstlenilen işin ücreti
                                                    ({this.state.selectedTermText}) aşağıdaki şekilde ödenecektir.
                                                </p>
                                            </div>
                                            <div>
                                                <p style={{fontWeight: "normal"}}>
                                                    Avukatın üstlendiği iş konusunda yetki belgesi ile başka bir
                                                    Avukatın da işin ifasına katılması halinde; Yetki belgesi ile işin
                                                    ifasına katılan Avukatın sözleşme tarafı Avukatın SGK kapsamında
                                                    çalışanı olması halinde yetki belgesi sunan Avukata ayrıca ücret
                                                    ödenmeyecek, işin ifası halinde Sözleşme tarafı Avukat ücretin
                                                    tamamını hak etmiş sayılacaktır. Yetki belgesi ile işin ifasına
                                                    katılan Avukatın sözleşme tarafı Avukatın SGK kapsamında çalışanı
                                                    olmaması halinde ise iş sahibi işin ifasına katılan Avukat sayısı
                                                    oranında ücreti Avukata ödeyecektir. Sözleşme tarafı Avukat, işin
                                                    ifasına katılan ve SGK kapsamında çalışanı olmayan Avukatların iş
                                                    sahibinden ücret ile ilgili talebi olmadığına dair yazılı beyan
                                                    getirmesi halinde ücretin tamamına hak kazanacaktır.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                    </div>

                                    <div>
                                   <textarea
                                       id={"priceNote"}
                                       data-vlength="0,120"
                                       style={{width: '100%', paddingBottom: 'inherit'}}
                                       // onBlur={this.validateField}
                                       value={this.state.contractNotes["priceNote"]}
                                       onChange={(e) => this.onChangeNotes(e)}
                                       rows={"7"}
                                       disabled={this.state.disabledDownloadButton}
                                   />
                                    </div>
                                </li>
                                <br/>
                                <li>
                                    <div>MASRAFLAR <label className='personal-informations-title' onClick={(e) => {
                                        this.setState({
                                            explanationModal: !this.state.explanationModal,
                                            explanationModalText: this.getExplanation("cost")
                                        })
                                    }}>(Açıklama için tıklayınız)</label></div>

                                    <div onChange={(e) => {
                                    }}>
                                        <div>
                                            <Row>
                                                <Col sm={12}>
                                                    <FormGroup row>
                                                        <Col sm={12}>
                                                            <input type="radio" value="byLawyer" name="cost"
                                                                   placeholder="Avukat"
                                                                   onChange={(e) => this.setState({
                                                                       selectedCost: e.target.value,
                                                                       selectedCostText: e.target.placeholder
                                                                   })}
                                                                   disabled={this.state.disabledDownloadButton}/> <label
                                                            className='select-content'> Masraflar
                                                            Avukat tarafından karşılanacaktır</label>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <input type="radio" value="byOwner" name="cost"
                                                                   placeholder="İş sahibi"
                                                                   onChange={(e) => this.setState({
                                                                       selectedCost: e.target.value,
                                                                       selectedCostText: e.target.placeholder
                                                                   }, () => document.getElementById("odenenMiktar").focus())}
                                                                   disabled={this.state.disabledDownloadButton}/>
                                                            <label
                                                                className='select-content'>Masraflar
                                                                iş sahibi tarafından karşılanacaktır</label>
                                                            {this.state.selectedCost === "byOwner" &&
                                                            <Col sm={12}>
                                                                <FormGroup row className='mt-2'>
                                                                    <Col sm={4}>
                                                                        <p for="odenenMiktar"
                                                                           style={{fontWeight: 'bold'}}>Avukata verilen
                                                                            avans miktarı TL veya döviz cinsi</p>
                                                                    </Col>
                                                                    <Col sm={8}>
                                                                        <Input type="numeric"
                                                                               id="odenenMiktar"
                                                                               className="form-control"
                                                                               style={{
                                                                                   border: '0.1em solid #000'
                                                                               }}
                                                                            // placeholder="Ödenen Miktar"
                                                                               value={this.state.odenenMiktar}
                                                                               onChange={(e) => this.setState({odenenMiktar: e.target.value})}
                                                                               disabled={this.state.disabledDownloadButton}
                                                                        />
                                                                    </Col>
                                                                </FormGroup>
                                                            </Col>}
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                            </Row><br/>
                                            <div>
                                                <p style={{fontWeight: "normal"}}>
                                                    Sözleşme ile üstlenilen işin masrafları
                                                    ({this.state.selectedCostText})
                                                    tarafından
                                                    karşılanacaktır. {this.state.selectedCost === "byOwner" ? "İşin ifası için Avukata (" + this.state.odenenMiktar + ") masraf avansı ödenmiştir." : ""}
                                                </p>
                                            </div>
                                            <div>
                                                <p style={{fontWeight: "normal"}}>
                                                    İfa edilecek işin tüm masrafları iş sahibi tarafından karşılanması
                                                    esastır. İşin ifası için Avukatın masraf yapması gerektiğinde bu
                                                    bedel Avukatın talebi üzerinde iş sahibi tarafından karşılanacak
                                                    veya en geç işin sonundaki hesapta nazara alınacaktır.
                                                </p>
                                            </div>
                                            <div>
                                                <Input type="text"
                                                       id="costExplanation"
                                                       className="form-control personal-informations-input"
                                                       style={{
                                                           border: '0.1em solid #000'
                                                       }}
                                                       placeholder="Açıklama"
                                                       value={this.state.contractNotes["costExplanation"]}
                                                       onChange={(e) => this.onChangeNotes(e)}
                                                       disabled={this.state.disabledDownloadButton}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <div>ÖZEL ŞARTLAR<label className='personal-informations-title' onClick={(e) => {
                                        this.setState({
                                            explanationModal: !this.state.explanationModal,
                                            explanationModalText: this.getExplanation("specialConditions")
                                        })
                                    }}>(Açıklama için tıklayınız)</label></div>

                                    <p style={{fontWeight: "normal"}}>
                                        İş sahibi işten feragat eder ya da avukata işi kovuşturma olanağı vermezse yahut
                                        sözleşmeyle yüklendiği vecibelerden birini yerine getirmezse avukat dava sonunda
                                        yüzde olarak anlaştığı ücretini istemek hakkını kazanacaktır.
                                    </p>
                                    <p style={{fontWeight: "normal"}}>
                                        İş sahibi yukarıda gösterilen adresi tebligat adresi kabul etmiştir. Avukatın
                                        kendisine yapacağı her türlü bildirim bu adrese gönderilecektir. Adres
                                        değişikliklerinin avukata bildirilmesi zorunlu olup, adres değişikliği nedeniyle
                                        iş
                                        sahibine ulaşmayan bildirimler nedeniyle avukata sorumluluk yüklenemez. Bunun
                                        dışında sesli telefon görüşmesi whatsapp veya benzer uygulama bildirimleri veya
                                        varsa mail bildirimleri de yazılı bildirim hükmünde kabul edilecektir.
                                    </p>
                                    <div>
                                        <textarea
                                            id={"specialConditionsNote"}
                                            data-vlength="0,120"
                                            style={{width: '100%', paddingBottom: 'inherit'}}
                                            // onBlur={this.validateField}
                                            value={this.state.contractNotes["specialConditionsNote"]}
                                            onChange={(e) => this.onChangeNotes(e)}
                                            rows={"7"}
                                            disabled={this.state.disabledDownloadButton}
                                        />
                                    </div>
                                </li>

                                <li>
                                    <div>TAHKİM ŞARTI, YETKİ VE GÖREV<label className='personal-informations-title'
                                                                            onClick={(e) => {
                                                                                this.setState({
                                                                                    explanationModal: !this.state.explanationModal,
                                                                                    explanationModalText: this.getExplanation("authority")
                                                                                })
                                                                            }}>(Açıklama için tıklayınız)</label></div>
                                    <div>

                                        <div onChange={(e) => {
                                            this.setState({
                                                selectedAuthority: e.target.value,
                                                selectedAuthorityText: e.target.placeholder
                                            })
                                        }}>
                                            <div>
                                                <Row>
                                                    <Col sm={12}>
                                                        <FormGroup row>
                                                            <Col sm={12}>
                                                                <input type="radio" value="arbitration" name="authority"
                                                                       placeholder="Barosu Tahkim Kurulu"
                                                                       disabled={this.state.disabledDownloadButton}/>
                                                                <label
                                                                    className='select-content'>Tahkim</label>
                                                            </Col>
                                                            <Col sm={12}>
                                                                <input type="radio" value="court" name="authority"
                                                                       placeholder="Mahkemeleri"
                                                                       disabled={this.state.disabledDownloadButton}/>
                                                                <label
                                                                    className='select-content'>Mahkeme</label>
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                        <br/>
                                        <div className='d-flex'>
                                            <p style={{fontWeight: "normal", paddingRight: '5px'}}>Sözleşme kapsamında
                                                doğacak
                                                uyuşmazlıklarda
                                            </p>
                                            <EditableLabel
                                                labelValue={this.state.editLabel}
                                                editChangeEvent={(text) => this.setState({editLabel: text})}
                                                style={{display: "inline"}}/>
                                            <p style={{paddingLeft: '5px'}}>{this.state.selectedAuthorityText}</p>
                                            <p style={{fontWeight: "normal", paddingLeft: '5px'}}>yetkili ve
                                                görevlidir. Olası uyuşmazlıklarda uygulanacak hukuk, Türk Hukukudur.</p>
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <div>İMZA<label className='personal-informations-title' onClick={(e) => {
                                        this.setState({
                                            explanationModal: !this.state.explanationModal,
                                            explanationModalText: this.getExplanation("signature")
                                        })
                                    }}>(Açıklama için tıklayınız)</label></div>
                                    <div>
                                        <Row style={{fontWeight: "normal"}}>
                                            <Col sm={12}>
                                                <FormGroup row>
                                                    <Col sm={6}>
                                                        <Label sm={12}>
                                                            {this.state.ownerInformation.ownerFormattedName}
                                                        </Label>
                                                        <Label sm={12}>
                                                            {this.state.ownerInformation.ownerIdentifier}
                                                        </Label>
                                                    </Col>
                                                    <Col sm={6} style={{textAlign: "right"}}>
                                                        <Label sm={12}>
                                                            {this.state.lawyerInformation.lawyerFormattedName}
                                                        </Label>
                                                        <Label sm={12}>
                                                            {this.state.lawyerInformation.lawyerIdentifier}
                                                        </Label>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row><br/><br/>
                                        <div style={{fontWeight: "normal", color: "grey"}}>
                                            <p>
                                                *Sözleşmenin 5070 Sayılı kanun kapsamında e-imza veya m-imza ile
                                                imzalanması
                                                halinde fiziki imza gerekmeyecektir.
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>

                    {
                        <DefaultModal isOpen={this.state.explanationModal}
                                      title="Açıklama"
                                      size="lg"
                                      confirmBtnText="Kapat"
                                      onConfirm={() => this.setState({explanationModal: !this.state.explanationModal}, () => console.log(document.getElementById("BarContract").outerHTML))}>
                            <ModalBody>
                                {this.state.explanationModalText}
                            </ModalBody>
                        </DefaultModal>

                    }

                    {
                        <DefaultModal isOpen={this.state.showTermAddModal}
                                      confirmBtnText="Kaydet"
                                      title="Vadeleri Tasarla"
                            // onConfirm={() => this.setState({showTermAddModal: false})}>
                                      onConfirm={this.validateTermValues}>
                            <ModalBody>
                                <div>
                                    <table className="contract-table"
                                           style={{textAlign: 'center', paddingBottom: "5px", width: "100%"}}>
                                        <thead>
                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                            <th width="5%">#</th>
                                            <th width="95%"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.termList && this.state.termList.map((item, index) =>
                                                <tr key={index}>
                                                    <td>{(index + 1).toString()}</td>
                                                    <td>
                                                        {
                                                            <div>
                                                                <Input type="text"
                                                                       id={"term_" + index}
                                                                       className="form-control"
                                                                       style={{
                                                                           border: '0.1em solid #000'
                                                                       }}
                                                                       placeholder="Vade"
                                                                       value={item["term_" + index]}
                                                                       onChange={(e) => this.onChangeTerms(e, index)}
                                                                />
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        </tbody>
                                    </table>
                                    <button type="button" onClick={this.addNewLine}
                                        // disabled={this.props.isLoading}
                                            style={{
                                                background: ' linear-gradient(rgb(134 193 243), #1085d8)',
                                                padding: '9px 45px 9px 20px'
                                            }}
                                            className="TekBtn ekle">Satır Ekle
                                    </button>
                                </div>
                            </ModalBody>

                        </DefaultModal>
                    }
                </div>
            </React.Fragment>
        );
    }

}

export default BarContractCreator;